<template>
  <div class="profile-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textPrimary">
          <span class="profile-dropdown__anchor min-w-max">
            <VaAvatar :size="32" color="primary">{{ avatarText }}</VaAvatar>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent
        class="profile-dropdown__content md:w-56 px-0 py-3 w-full"
        :style="{ '--hover-color': hoverColor }"
      >
        <VaList>
          <header class="text-[var(--va-secondary)] font-bold text-xs px-4 mb-2">
            {{ authStore.user?.nickname || authStore.user?.username || '用户' }}
          </header>
          <VaListItem class="menu-item px-4 text-base cursor-pointer h-8" @click="goAccount">
            <VaIcon name="mso-account_circle" class="pr-1" color="secondary" />
            账号中心
          </VaListItem>
          <VaListSeparator class="mx-3 my-2" />
          <VaListItem class="menu-item px-4 text-base cursor-pointer h-8" @click="logout">
            <VaIcon name="mso-logout" class="pr-1" color="secondary" />
            退出登录
          </VaListItem>
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useColors } from 'vuestic-ui'
import { useAuthStore } from '../../../../stores/auth'

const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))
const authStore = useAuthStore()
const router = useRouter()
const isShown = ref(false)

const avatarText = computed(() =>
  (authStore.user?.nickname || authStore.user?.username || '用').slice(0, 1).toUpperCase(),
)

const goAccount = () => {
  isShown.value = false
  router.push({ name: 'account' })
}

const logout = async () => {
  isShown.value = false
  await authStore.logout()
  router.push({ name: 'login' })
}
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}
</style>
